import * as React from 'react';

import { mergeClassNames } from '@/lib/utils';

const GoogleCalendarIcon = ({
  className,
  ...props
}: React.ComponentProps<'svg'>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={mergeClassNames('h-5 w-5', className)}
    {...props}
  >
    <g clipPath="url(#clip0_415_128)">
      <path d="M15.268 4.74H4.74V15.268H15.268V4.74Z" fill="white" />
      <path d="M15.26 20L20 15.26H15.26V20Z" fill="#EA4335" />
      <path d="M20 4.74H15.26V15.268H20V4.74Z" fill="#FBBC04" />
      <path d="M15.268 15.26H4.74V20H15.268V15.26Z" fill="#34A853" />
      <path
        d="M0 15.26V18.416C0 19.292 0.708 20 1.58 20H4.736V15.26H0Z"
        fill="#188038"
      />
      <path
        d="M20 4.74L20 1.58C20 0.708 19.292 0 18.42 0H15.264V4.74L20 4.74Z"
        fill="#1967D2"
      />
      <path
        d="M15.26 0H1.58C0.708 0 0 0.708 0 1.58V15.264H4.74L4.74 4.74H15.268L15.26 0Z"
        fill="#4285F4"
      />
      <path
        d="M6.896 12.904C6.5 12.64 6.232 12.252 6.08 11.736L6.996 11.36C7.08 11.676 7.224 11.92 7.428 12.096C7.636 12.268 7.884 12.352 8.176 12.352C8.472 12.352 8.732 12.264 8.944 12.08C9.16 11.896 9.268 11.664 9.268 11.384C9.268 11.1 9.156 10.864 8.928 10.68C8.7 10.5 8.416 10.408 8.076 10.408H7.548V9.504H8.02C8.312 9.504 8.56 9.424 8.76 9.264C8.96 9.108 9.06 8.888 9.06 8.616C9.06 8.368 8.972 8.176 8.792 8.032C8.612 7.888 8.384 7.812 8.112 7.812C7.844 7.812 7.632 7.884 7.472 8.028C7.316 8.172 7.196 8.352 7.128 8.556L6.224 8.18C6.344 7.84 6.564 7.54 6.884 7.28C7.208 7.024 7.62 6.888 8.12 6.888C8.492 6.888 8.824 6.96 9.116 7.104C9.408 7.248 9.644 7.448 9.812 7.696C9.98 7.948 10.064 8.236 10.064 8.552C10.064 8.876 9.984 9.144 9.828 9.372C9.672 9.596 9.48 9.768 9.252 9.888V9.944C9.544 10.064 9.8 10.264 9.988 10.52C10.18 10.776 10.272 11.084 10.272 11.44C10.272 11.8 10.184 12.116 10 12.396C9.82 12.676 9.568 12.896 9.248 13.056C8.928 13.216 8.568 13.3 8.168 13.3C7.716 13.3 7.288 13.168 6.896 12.904ZM12.504 8.372L11.5 9.1L11 8.34L12.796 7.044H13.488V13.164H12.504V8.372Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_415_128">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GoogleCalendarIcon;
